import EFPicture from 'elem/compCommon/EFPicture';
import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('homebattery');
    const [open, setOpen] = useState(true);

    const listText = [
        {
            text: t('secA_list_1'),
            id: '#B',
        },
        {
            text: t('secA_list_2'),
            id: '#C',
        },
        {
            text: t('secA_list_3'),
            id: '#D',
        },
        {
            text: t('secA_list_4'),
            id: '#E',
        },
        {
            text: t('secA_list_5'),
            id: '#F',
        },
        {
            text: t('secA_list_6'),
            id: '#G',
        },
    ];

    const onClick = () => {
        setOpen(!open);
    };

    return (
        <div className={`home-battery-A home-battery-box ${css['home-battery-A']}`}>
            <h1 className="title main">{t('secA_title')}</h1>
            <p className="desc black">{t('secA_desc')}</p>
            <Link
                className="img-box"
                href="/delta-pro-3-portable-power-station"
                aria={t('secA_title')}
                alt={t('secA_title')}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: 'EcoFlow DELTA Pro 3',
                    position: 'Product Preview',
                }}
            >
                <EFPicture
                    src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950030458/a_1366.jpg"
                    srcPad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950030458/a_1366.jpg"
                    srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950030240/a_375.jpg"
                    alt={t('secA_title')}
                />
            </Link>
            <div className="list-section">
                <p className="title" onClick={onClick}>
                    {t.rich('secA_list_header', {
                        gray: (text: string) => <span className="gray">{open ? '閉じる' : '開く'}</span>,
                    })}
                </p>
                <ul className={open ? 'open' : 'close'}>
                    {listText.map((item, index) => (
                        <li key={index}>
                            <Link
                                href={`/home-battery${item.id}`}
                                aria={item.text}
                                alt={item.text}
                                // dataLayer={{
                                //     event: 'uaEvent',
                                //     event_name: 'select_banner',
                                //     banner_name: t('secA_title'),
                                //     button_name: item.text,
                                // }}
                            >
                                {item.text}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
